(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["content-popup"] && !Shopify.designMode) return;
  try {
    
  class ContentPopup extends HTMLElement {
    constructor() {
      super();
      this.handleOpen = this.handleOpen.bind(this);
      this.handleClose = this.handleClose.bind(this);
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.text = this.querySelector('[text]');
      this.content = this.querySelector('[content]');
      this.addEventListener('click', this.handleClick);
      window.addEventListener('content-popup:open', this.handleOpen);
      window.addEventListener('content-popup:close', this.handleClose);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      window.removeEventListener('content-popup:open', this.handleOpen);
      window.removeEventListener('content-popup:close', this.handleClose);
    }

    handleOpen() {
      this.hidden = false;
    }

    handleOpen(event) {
      this.hidden = false;

      console.log(event.detail);

      if(this.text){
        this.text.innerHTML = event.detail?.text;
      } else {
        this.text = this.querySelector('[text]');
        if (this.text) {
          this.text.innerHTML = event.detail?.text;
        }
      }
      this.text.innerHTML = event.detail?.text;

      if(this.content){
        this.content.innerHTML = this.htmlDecode(event.detail?.content);
      } else {
        this.content = this.querySelector('[content]');
        if (this.content) {
          this.content.innerHTML = this.htmlDecode(event.detail?.content);
        }
      }
      this.content.innerHTML = this.htmlDecode(event.detail?.content);
    }

    handleClose() {
      this.hidden = true;
    }

    handleClick(event) {
      if (event.target.closest("[data-content-popup-close]") || event.target === this) {
        this.handleClose();
      }
    }

    htmlDecode(input) {
      let doc = new DOMParser().parseFromString(input, "text/html");
      return doc.documentElement.textContent;
    }
  }
  customElements.define("content-popup", ContentPopup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  const menuToggles = document.querySelectorAll('.shopify-section-header [data-toggle-menu]');
  const menuWrapper = document.querySelector('.shopify-section-header [data-menu]');
  const mainContainer = document.querySelector('main');
  const footerContainer = document.querySelector('footer');
  function debounce(func, wait) {
    let timeout;
    return function(...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func.apply(context, args);
      }, wait);
    };
  }
  const setOverlayHeight = debounce(() => {
    menuWrapper.style = `--height: ${mainContainer.getBoundingClientRect().height + footerContainer.getBoundingClientRect().height}px`;
  }, 100);
  document.addEventListener('DOMContentLoaded', setOverlayHeight);
  window.addEventListener('resize', setOverlayHeight);
  window.addEventListener('cio:updated', setOverlayHeight);

  const setExpanded = (element, expanded) => {
    element.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  };

  const openMenu = () => {
    menuWrapper.setAttribute('data-menu', 'open');
    menuToggles.forEach((toggle) => setExpanded(toggle, true));
  };

  const closeMenu = () => {
    menuWrapper.setAttribute('data-menu', 'closed');
    menuToggles.forEach((toggle) => setExpanded(toggle, false));
  };

  document.body.addEventListener('click', (event) => {
    const menuToggle = event.target.closest('[data-toggle-menu]');
    if (menuToggle) {
      const state = menuWrapper?.getAttribute('data-menu');
      state === 'open' ? closeMenu() : openMenu();
      return;
    }

    const isBackdropClick = event.target === menuWrapper;
    if (isBackdropClick) {
      closeMenu();
      return;
    }

    const submenuToggle = event.target.closest('[data-toggle-submenu]');
    if (submenuToggle) {
      const expanded = submenuToggle.getAttribute('aria-expanded') === 'true';
      setExpanded(submenuToggle, !expanded);
      return;
    }

    const announcementLink = event.target.closest('.store-announcement[data-business]');
    if (announcementLink) {
      try {
        window.Shopify?.analytics?.publish('mx:gtm_bridge_subscriber', {
          event: 'custom_event',
          event_name: 'select_brandtab',
          select_brandtab: {
            business: announcementLink?.dataset?.business || '',
          },
        });
      } catch {}
      return;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-widget"] && !Shopify.designMode) return;
  try {
    
  class NewsletterWidget extends HTMLElement {
    // Positioning runs on every scroll event, so the expensive parts — resolving
    // #MainContent, and reading the CSS-authored offsets back out of computed
    // style — are cached and only refreshed on resize. See #measure().
    #main = null;
    #metrics = null;
    #frame = 0;
    #lastTop = null;

    constructor() {
      super();
      this.handleClose = this.handleClose.bind(this);
      this.handleClick = this.handleClick.bind(this);
      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      const isDesignMode = window.Shopify.designMode;
      const newsletterEnabled = window.theme.settings.newsletterEnabled;

      if (
        (localStorage.getItem("closedNewsletterWidget") === "true" &&
          !isDesignMode) ||
        !newsletterEnabled
      ) {
        this.remove();
        return;
      }
      this.hidden = false;
      this.addEventListener("click", this.handleClick);
      window.addEventListener("scroll", this.handleScroll, { passive: true });
      window.addEventListener("resize", this.handleResize);
      this.scheduleUpdate();
    }

    disconnectedCallback() {
      if (this.#frame) {
        cancelAnimationFrame(this.#frame);
        this.#frame = 0;
      }
      this.removeEventListener("click", this.handleClick);
      window.removeEventListener("scroll", this.handleScroll);
      window.removeEventListener("resize", this.handleResize);
    }

    handleClose() {
      this.hidden = true;
      localStorage.setItem("closedNewsletterWidget", "true");
      return;
    }

    handleClick(event) {
      const closeButton = event.target.closest("[data-newsletter-widget-close]");
      const clickedWidget = event.target.closest("newsletter-widget");

      if (!clickedWidget) {
        return;
      }

      if (closeButton) {
        this.handleClose();
        return;
      }

      if (window.innerWidth > 900) {
        window.dispatchEvent(new CustomEvent("newsletter-popup:open"));
        return;
      }

      const loginLink = this.dataset.loginLink;

      if (loginLink) {
        const newsletterLink = new URL(loginLink, window.location.origin);
        newsletterLink.searchParams.set(
          "mx_source",
          this.dataset.newsletterSource || "newsletter_flag",
        );
        window.location.href = newsletterLink.toString();
      }
    }

    handleScroll() {
      this.scheduleUpdate();
    }

    handleResize() {
      // Viewport width can cross the 900px breakpoint and % offsets resolve
      // against the viewport, so the cached measurements no longer hold.
      this.#metrics = null;
      this.scheduleUpdate();
    }

    // Scroll fires far faster than the compositor can use, so coalesce to one
    // update per frame.
    scheduleUpdate() {
      if (this.#frame || this.hidden) {
        return;
      }
      this.#frame = requestAnimationFrame(() => {
        this.#frame = 0;
        this.updateWidgetPositionWithinMain();
      });
    }

    // The CSS-authored offset is only visible with our own inline value cleared,
    // and reading it back out of computed style right after clearing it forces a
    // synchronous style + layout flush. That used to happen on every scroll
    // event; now it happens once, and again only on resize.
    #measure() {
      const previousTop = this.style.top;
      const previousBottom = this.style.bottom;
      this.style.top = "";
      this.style.bottom = "";

      const computedStyle = window.getComputedStyle(this);
      const height = this.getBoundingClientRect().height;
      const preferredTop =
        this.dataset.verticalAlignment == "top"
          ? parseFloat(computedStyle.top)
          : window.innerHeight - parseFloat(computedStyle.bottom) - height;

      this.style.top = previousTop;
      this.style.bottom = previousBottom;

      this.#metrics = { preferredTop, height };
    }

    updateWidgetPositionWithinMain() {
      if (this.hidden) {
        return;
      }

      this.#main ??= document.querySelector("#MainContent");
      if (!this.#main) {
        return;
      }

      if (!this.#metrics) {
        this.#measure();
      }
      const { preferredTop, height } = this.#metrics;

      // Read before writing: #MainContent moves with the scroll position, so this
      // one is genuinely per-frame, but nothing has invalidated layout since the
      // last frame's write.
      const mainRect = this.#main.getBoundingClientRect();

      // + and - 16 for gap between header and footer
      const clampedTop = Math.min(
        Math.max(preferredTop, mainRect.top + 16),
        mainRect.bottom - height - 16,
      );

      const top = `${clampedTop}px`;
      if (this.#lastTop === top) {
        return;
      }
      this.#lastTop = top;
      this.style.top = top;
      this.style.bottom = "auto";
    }
  }
  customElements.define("newsletter-widget", NewsletterWidget);

  } catch(e) { console.error(e); }
})();
})();
